var render = function render(){var _vm=this,_c=_vm._self._c;return _c('star-rate',{key:_vm.value_,attrs:{"disabled":!!_vm.disabled,"active-color":"#F70B0D","count":3,"type":"heart","on-change":()=>{_vm.$emit('input', _vm.value_)}},model:{value:(_vm.value_),callback:function ($$v) {_vm.value_=$$v},expression:"value_"}})
}
var staticRenderFns = []

export { render, staticRenderFns }